var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-code',_vm._b({staticClass:"my-0"},'app-code',_vm.$attrs,false),[_c('prism',{ref:"code",attrs:{"code":_vm.code,"inline":_vm.inline,"language":_vm.language}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }